import { Button, LuIcon } from "@overmap-ai/blocks"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { modelIconMapping } from "../../mappings/icons"
import { BaseTopBar } from "../TopBars/BaseTopBar"

export const ProcedureInitiativeDetailViewTopBar = memo(() => {
	return (
		<BaseTopBar
			leftContent={
				<Link
					from="/$organizationId/$projectId/initiatives/$procedureInitiativeId"
					to="/$organizationId/$projectId/initiatives"
				>
					<Button variant="ghost" accentColor="base">
						<LuIcon icon={modelIconMapping.arrowLeft} />
						Initiatives
					</Button>
				</Link>
			}
		/>
	)
})
ProcedureInitiativeDetailViewTopBar.displayName = "ProcedureInitiativeDetailViewTopBar"
